(function () {
  var geenBeweging = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* achtergrondvideo in het split-screen keuzescherm.
     Bron staat in data-src zodat hij niet gedownload wordt als beweging uit staat. */
  var loopVid = document.querySelector("video[data-sxloop]");
  if (loopVid && !geenBeweging) {
    loopVid.addEventListener("canplay", function () { loopVid.classList.add("on"); });
    loopVid.src = loopVid.dataset.src;
    var spelen = loopVid.play();
    if (spelen && spelen.catch) spelen.catch(function () { /* autoplay geweigerd: foto blijft staan */ });
  }

  /* productvideo die meedraait met de scrollpositie */
  var sv = document.querySelector("[data-scrollvid]");
  if (sv && !geenBeweging && "IntersectionObserver" in window) {
    var svVid = sv.querySelector("video");
    var duur = 0;
    var gepland = false;
    var geladen = false;

    var bijwerken = function () {
      gepland = false;
      if (!duur) return;
      var r = sv.getBoundingClientRect();
      var loop = r.height - window.innerHeight;
      if (loop <= 0) return;
      var p = Math.max(0, Math.min(1, -r.top / loop));
      sv.classList.toggle("scrubbing", p > 0.06);
      var t = p * (duur - 0.06);
      if (Math.abs(svVid.currentTime - t) > 0.02) svVid.currentTime = t;
    };

    svVid.addEventListener("loadedmetadata", function () {
      duur = svVid.duration || 0;
      /* iOS rendert pas frames na een korte play/pause */
      var p = svVid.play();
      if (p && p.then) p.then(function () { svVid.pause(); }).catch(function () {});
      sv.classList.add("ready");
      bijwerken();
    });

    new IntersectionObserver(function (entries, obs) {
      if (entries[0].isIntersecting && !geladen) {
        geladen = true;
        svVid.src = svVid.dataset.src;
        svVid.load();
        obs.disconnect();
      }
    }, { rootMargin: "400px 0px" }).observe(sv);

    window.addEventListener("scroll", function () {
      if (!gepland) { gepland = true; requestAnimationFrame(bijwerken); }
    }, { passive: true });
    window.addEventListener("resize", bijwerken, { passive: true });
  }

  /* draaiend bitje zonder achtergrond, wisselt vanzelf van kleur */
  var bv = document.querySelector("[data-bitvid]");
  if (bv && !geenBeweging && "IntersectionObserver" in window) {
    var bvVid = bv.querySelector("video");
    var knoppen = [].slice.call(bv.querySelectorAll(".bitvid-kleur"));
    var actief = 0;
    var zelfWisselen = null;

    var toon = function (i) {
      actief = i;
      knoppen.forEach(function (k, n) { k.setAttribute("aria-pressed", n === i ? "true" : "false"); });
      bvVid.classList.remove("on");
      bvVid.src = knoppen[i].dataset.src;
      var p = bvVid.play();
      if (p && p.catch) p.catch(function () {});
    };

    bvVid.addEventListener("canplay", function () { bvVid.classList.add("on"); });
    bvVid.addEventListener("error", function () {
      /* kleur nog niet gerenderd: knop uitschakelen zodat de cyclus 'm overslaat */
      knoppen[actief].disabled = true;
      knoppen[actief].style.opacity = ".3";
    });

    knoppen.forEach(function (k, i) {
      k.addEventListener("click", function () {
        if (zelfWisselen) { clearInterval(zelfWisselen); zelfWisselen = null; }
        toon(i);
      });
    });

    new IntersectionObserver(function (entries, obs) {
      if (entries[0].isIntersecting) {
        obs.disconnect();
        toon(0);
        zelfWisselen = setInterval(function () {
          var volgende = actief;
          for (var n = 0; n < knoppen.length; n++) {
            volgende = (volgende + 1) % knoppen.length;
            if (!knoppen[volgende].disabled) break;
          }
          if (volgende !== actief) toon(volgende);
        }, 5000);
      }
    }, { rootMargin: "300px 0px" }).observe(bv);
  }

  /* sticky CTA-bar op home pas na de hero */
  var bar = document.getElementById("sxCtaBar");
  if (bar) {
    var onScroll = function () {
      bar.classList.toggle("show", window.scrollY > window.innerHeight * 0.6);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
  }

  /* PDP: kleur-swatches */
  var swatches = document.querySelectorAll(".swatch");
  var variantInput = document.getElementById("sxVariantId");
  var swatchName = document.getElementById("swatchName");
  var galMain = document.getElementById("galMain");
  var losPrice = document.getElementById("losPrice");
  var optLos = document.getElementById("optLos");
  swatches.forEach(function (s) {
    s.addEventListener("click", function () {
      if (s.disabled) return;
      swatches.forEach(function (x) { x.classList.remove("sel"); });
      s.classList.add("sel");
      if (variantInput) variantInput.value = s.dataset.variantId;
      if (swatchName) swatchName.textContent = s.dataset.title;
      if (galMain && s.dataset.image) galMain.src = s.dataset.image;
      if (losPrice) losPrice.textContent = s.dataset.price;
      if (optLos) {
        optLos.dataset.price = s.dataset.price;
        if (optLos.classList.contains("sel")) {
          var p = document.getElementById("atcPrice");
          if (p) p.textContent = s.dataset.price;
        }
      }
    });
  });

  /* PDP: 360-standje. De galerij wisselt naar donker zodra de clip draait,
     want de clips hebben een zwart vlak in plaats van een alfakanaal. */
  var galerij = document.querySelector(".gallery");
  var galVid = document.getElementById("galVid");
  var knop360 = document.getElementById("gal360");
  if (galerij && galVid && knop360 && swatches.length && !geenBeweging) {
    var huidigeClip = function () {
      var sel = document.querySelector(".swatch.sel") || swatches[0];
      return sel ? sel.dataset.video : null;
    };
    var videoAan = false;

    var zetUit = function () {
      videoAan = false;
      galerij.classList.remove("video-aan");
      knop360.setAttribute("aria-pressed", "false");
      galVid.pause();
    };

    galVid.addEventListener("error", function () {
      /* geen clip voor deze kleur: knop weg, foto blijft */
      zetUit();
      knop360.hidden = true;
    });

    knop360.hidden = false;
    knop360.addEventListener("click", function () {
      if (videoAan) { zetUit(); return; }
      var bron = huidigeClip();
      if (!bron) return;
      videoAan = true;
      if (galVid.getAttribute("src") !== bron) galVid.src = bron;
      galerij.classList.add("video-aan");
      knop360.setAttribute("aria-pressed", "true");
      var p = galVid.play();
      if (p && p.catch) p.catch(function () {});
    });

    swatches.forEach(function (s) {
      s.addEventListener("click", function () {
        if (!videoAan || !s.dataset.video) return;
        galVid.src = s.dataset.video;
        var p = galVid.play();
        if (p && p.catch) p.catch(function () {});
      });
    });

    document.querySelectorAll(".gal-thumbs img").forEach(function (t) {
      t.addEventListener("click", zetUit);
    });
  }

  /* PDP: aankoopkeuze abonnement/eenmalig */
  var optAbo = document.getElementById("optAbo");
  var atcPrice = document.getElementById("atcPrice");
  var atcSub = document.getElementById("atcSub");
  var planInput = document.getElementById("sxSellingPlan");

  function pick(el, other) {
    el.classList.add("sel");
    other.classList.remove("sel");
    el.querySelector("input").checked = true;
    if (atcPrice) atcPrice.textContent = el.dataset.price;
    if (atcSub) atcSub.textContent = el.dataset.sub;
    if (planInput) {
      var planId = optAbo.dataset.planId;
      if (el === optAbo && planId) {
        planInput.value = planId;
        planInput.disabled = false;
      } else {
        planInput.value = "";
        planInput.disabled = true;
      }
    }
  }
  if (optAbo && optLos) {
    optAbo.addEventListener("click", function () { pick(optAbo, optLos); });
    optLos.addEventListener("click", function () { pick(optLos, optAbo); });
    pick(optAbo, optLos);
  }

  /* policy-pagina's: Shopify zet hier een vaste Engelse titel neer */
  var policyTitle = document.querySelector(".shopify-policy__title h1");
  if (policyTitle) {
    var vertaling = {
      "Refund policy": "Retourbeleid",
      "Privacy policy": "Privacybeleid",
      "Terms of service": "Algemene voorwaarden",
      "Shipping policy": "Verzendbeleid",
      "Contact information": "Contactgegevens",
      "Legal notice": "Juridische informatie",
    };
    var nl = vertaling[policyTitle.textContent.trim()];
    if (nl) {
      policyTitle.textContent = nl;
      document.title = nl + " — Shockx";
    }
  }

  /* PDP: galerij-thumbs */
  document.querySelectorAll(".gal-thumbs img").forEach(function (t) {
    t.addEventListener("click", function () { if (galMain) galMain.src = t.dataset.full; });
  });

})();
